var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94225 8.39182C6.81484 8.26464 6.663 8.16458 6.49587 8.09767L1.2092 5.97767C1.14608 5.95234 1.09222 5.90831 1.05484 5.85148C1.01747 5.79466 0.998368 5.72776 1.00011 5.65977C1.00185 5.59178 1.02435 5.52595 1.06458 5.47111C1.10482 5.41628 1.16087 5.37506 1.2252 5.353L13.8919 1.01967C13.9509 0.998329 14.0149 0.994257 14.0762 1.00793C14.1375 1.0216 14.1936 1.05244 14.238 1.09685C14.2824 1.14126 14.3133 1.1974 14.3269 1.2587C14.3406 1.32 14.3365 1.38393 14.3152 1.443L9.98187 14.1097C9.95981 14.174 9.91859 14.23 9.86376 14.2703C9.80892 14.3105 9.74309 14.333 9.6751 14.3348C9.60711 14.3365 9.54021 14.3174 9.48339 14.28C9.42656 14.2427 9.38253 14.1888 9.3572 14.1257L7.2372 8.83767C7.16999 8.67066 7.06966 8.519 6.94225 8.39182ZM6.94225 8.39182L14.2359 1.09967",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.762b5fb520e74bfea7c8d9f72d016849.svg";
export { ForwardRef as ReactComponent };